import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Collapse, Button,
} from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';

import Section from './Section';
import Icf from './Icf';

export default function Certifications({ coach }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-5">
      <Row>
        <Col>
          <Button
            variant="link"
            className="fs-4 text-decoration-none text-gray-900 fw-semibold"
            onClick={() => setOpen(!open)}
            aria-controls={`coach-${coach.id}-certifications-section`}
            aria-expanded={open}
          >
            Certifications
          </Button>
        </Col>

        <Col xs="auto">
          <Button
            variant="light"
            className="ms-3 p-0 collapsed"
            style={{ borderRadius: '50%', borderBottomLeftRadius: '0' }}
            onClick={() => setOpen(!open)}
            data-bs-toggle="collapse"
            data-bs-target={`#coach-${coach.id}-certifications-section`}
            aria-controls={`coach-${coach.id}-certifications-section`}
            aria-expanded={open}
          >
            <IconWithText
              iconClassName="chevron-icon small-icon icon-toggle"
              wrapperClassName="p-2"
            />
          </Button>
        </Col>
      </Row>

      <Collapse in={open}>
        <Row id={`coach-${coach.id}-certifications-section`} className="pt-2">
          <Col lg={6} xl={4}>
            <Section
              id={`coach-${coach.id}-coach_associations`}
              title="Coaching Associations and Networks"
              collection={coach.attributes.coach_associations}
            />
          </Col>

          <Col lg={6} xl={4}>
            <Section
              id={`coach-${coach.id}-methodologies`}
              title="Coaching Methodology"
              collection={coach.attributes.methodologies}
            />
          </Col>

          <Col lg={6} xl={4}>
            <Icf coach={coach} />
          </Col>
        </Row>
      </Collapse>
    </div>
  );
}

Certifications.propTypes = {
  coach: PropTypes.object.isRequired,
};
